<template>
  <div class="w3-top">
    <div class="w3-bar" id="myNavbar">
      <a
        class="w3-bar-item w3-button w3-hover-black w3-hide-medium w3-hide-large w3-right w3-bar-block w3-white"
        href="javascript:void(0);"
        @click="toggleFunction()"
        title="Toggle Navigation Menu"
      >
        <i class="fa fa-bars"></i>
      </a>
      <a href="#home" class="w3-bar-item w3-button w3-bar-block w3-white"
        >HOME</a
      >
      <a
        href="#about"
        class="w3-bar-item w3-button w3-hide-small w3-bar-block w3-white"
        >ABOUT</a
      >
      <a
        href="#access"
        class="w3-bar-item w3-button w3-hide-small w3-bar-block w3-white"
        >ACCESS</a
      >
      <a
        href="#rooms"
        class="w3-bar-item w3-button w3-hide-small w3-bar-block w3-white"
        >ROOMS</a
      >
      <a
        href="#informations"
        class="w3-bar-item w3-button w3-hide-small w3-bar-block w3-white"
        >AREA INFO</a
      >
      <a
        href="#contact"
        class="w3-bar-item w3-button w3-hide-small w3-bar-block w3-white"
        >CONTACT US</a
      >
      <a
        href="https://www.sphiearth.com"
        class="w3-bar-item w3-button w3-hide-small w3-bar-block w3-white"
        >PMS</a
      >
    </div>
    <!-- Navbar on small screens -->
    <div
      id="navDemo"
      class="w3-bar-block w3-white w3-hide w3-hide-large w3-hide-medium"
    >
      <a href="#about" class="w3-bar-item w3-button" @click="toggleFunction()"
        >ABOUT</a
      >
      <a href="#access" class="w3-bar-item w3-button" @click="toggleFunction()"
        >ACCESS</a
      >
      <a href="#rooms" class="w3-bar-item w3-button" @click="toggleFunction()"
        >ROOMS</a
      >
      <a
        href="#informations"
        class="w3-bar-item w3-button"
        @click="toggleFunction()"
        >AREA INFO</a
      >
      <a href="#contact" class="w3-bar-item w3-button" @click="toggleFunction()"
        >CONTACT US</a
      >
      <a
        href="https://www.sphiearth.com"
        class="w3-bar-item w3-button"
        @click="toggleFunction()"
        >PMS</a
      >
    </div>
  </div>

  <!-- First Parallax Image with Logo Text -->
  <div class="bgimg-1 w3-display-container w3-opacity-min" id="home">
    <div class="w3-display-middle" style="white-space: nowrap">
      <span
        class="w3-center w3-padding-large w3-black w3-xlarge w3-wide w3-animate-opacity"
        >Sophiearth Hotel
      </span>
      <p style="background-color: black; color: rgb(195, 162, 162)">
        <span style="padding-left: 80px" @click="setLanguage('jp')">日本語</span
        >&nbsp;&nbsp;&nbsp;
        <span @click="setLanguage('en')">English</span>&nbsp;&nbsp;&nbsp;
        <span @click="setLanguage('kr')">한국어</span>&nbsp;&nbsp;&nbsp;
        <span @click="setLanguage('cn')">中文</span>
      </p>
      <br />
      <p
        style="background-color: black; color: white;  text-align: center; /*margin-top: 5px; width: 300px*/"
      >&nbsp;</p>
      <p
        v-for="line in okubo_elementary_school"
        :key="line"
        style="background-color: black; color: white;  text-align: center;/* width: 300px*/"
        v-html="line"
      >
      </p>
      <p
        style="background-color: black; color: white;  text-align: center; /*margin-bottom: 5px; width: 300px*/"
      >&nbsp;</p>
    </div>
  </div>

  <AboutView />

  <!-- Second Parallax Image with Portfolio Text -->
  <div class="bgimg-2 w3-display-container w3-opacity-min">
    <div class="w3-display-middle">
      <span class="w3-xxlarge w3-text-white w3-wide">ACCESS</span>
    </div>
  </div>

  <AccessView />

  <!-- Third Parallax Image with Portfolio Text -->
  <div class="bgimg-3 w3-display-container w3-opacity-min">
    <div class="w3-display-middle">
      <span class="w3-xxlarge w3-text-white w3-wide">ROOMS</span>
    </div>
  </div>

  <DisplayRooms />

  <!-- Third Parallax Image with Portfolio Text -->
  <div class="bgimg-4 w3-display-container w3-opacity-min">
    <div class="w3-display-middle">
      <span class="w3-xxlarge w3-text-white w3-wide">AREA INFO</span>
    </div>
  </div>

  <InformationView />

  <!-- Third Parallax Image with Portfolio Text -->
  <div class="bgimg-5 w3-display-container w3-opacity-min">
    <div class="w3-display-middle">
      <span class="w3-xxlarge w3-text-white w3-wide">CONTACT US</span>
    </div>
  </div>

  <ContactView></ContactView>

  <!-- Footer -->
  <!--
  class="w3-center w3-black w3-padding-64 w3-opacity w3-hover-opacity-off"
-->
  <footer class="w3-black w3-padding-64">
    <div style="margin-left: 20px; margin-right: 10px">
      <h4><strong>特定商取引法に基づく表示</strong></h4>
      <p>販売業者の正式名称: ソフィアース アパートメント</p>
      <p>所在地: 新宿区大久保1-7-26 1F</p>
      <p>電話番号: 03)5155-2651</p>
      <p>メールアドレス: sophiearth@naver.com</p>
      <p>運営統括責任者: 金 松貞</p>
      <p>商品代金以外の必要料金:</p>
      <p style="margin-left: 25px">
        喫煙による臭いや破片の損傷が被害である場合は、元の状態に戻す費用を請求することができます。
      </p>
      <p>返品・交換の方法:</p>
      <p style="margin-left: 25px">
        相互に合意した方法に従って期間内にキャンセル通知をした場合、無料でキャンセルすることができ、すでに支払いが行われている場合は払い戻しが行われます。
      </p>
      <p>支払い方法:</p>
      <p style="margin-left: 25px">
        お支払いは原則として宿泊施設到着時に行われますが、事前の通知なくチェックインをされなかった場合、または合意期間を過ぎてからキャンセル通知をされた場合は、通知されたクレジットカードで合意金額を支払うことができます。
      </p>
      <p>支払い時期: クレジットカード： 支払理由の発生直後</p>
      <p>販売価格:</p>
      <p style="margin-left: 25px">
        料金は上部の部屋の説明セクションに記載されています。
      </p>
    </div>
  </footer>
</template>

<script>
import { language_util } from "@/classes/language/language_util.js";
import { about } from "@/classes/about/about.js";
import { onMounted, computed } from "vue";
import AboutView from "@/views/about/AboutView.vue";
import AccessView from "@/views/access/AccessView.vue";
import DisplayRooms from "@/views/rooms/DisplayRooms.vue";
import InformationView from "@/views/informations/InformationView.vue";
import ContactView from "@/views/contact_us/ContactView.vue";

export default {
  components: {
    AboutView,
    AccessView,
    DisplayRooms,
    InformationView,
    ContactView,
  },
  setup() {
    const my_language = computed(() => language_util.get_language());

    const okubo_elementary_school = computed(() => {
      return about.get_okubo(my_language.value);
    });

    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });
    // Modal Image Gallery
    function onClick(element) {
      document.getElementById("img01").src = element.src;
      document.getElementById("modal01").style.display = "block";
      var captionText = document.getElementById("caption");
      captionText.innerHTML = element.alt;
    }

    // Change style of navbar on scroll
    //window.onscroll = function() {myFunction()};
    function handleScroll() {
      var navbar = document.getElementById("myNavbar");
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        navbar.className =
          "w3-bar" + " w3-card" + " w3-animate-top" + " w3-white";
      } else {
        navbar.className = navbar.className.replace(
          " w3-card w3-animate-top w3-white",
          ""
        );
      }
    }

    // Used to toggle the menu on small screens when clicking on the menu button
    function toggleFunction() {
      var x = document.getElementById("navDemo");
      if (x.className.indexOf("w3-show") == -1) {
        x.className += " w3-show";
      } else {
        x.className = x.className.replace(" w3-show", "");
      }
    }

    function setLanguage(lang) {
      language_util.set_language(lang);
    }

    return {
      okubo_elementary_school,
      onClick,
      toggleFunction,
      setLanguage,
    };
  },
};
</script>

<style>
</style>